import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    // Lê a preferência do usuário do localStorage, ou usa 'system' como padrão.
    const [themePreference, setThemePreference] = useState(() => {
        return localStorage.getItem('theme') || 'system';
    });

    // O tema real que será aplicado ('light' or 'dark')
    const [actualTheme, setActualTheme] = useState('light');

    // Função que determina qual tema aplicar com base na preferência
    const applyTheme = useCallback((pref) => {
        let newTheme;
        if (pref === 'system') {
            // Verifica a preferência do sistema operacional
            const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            newTheme = systemPrefersDark ? 'dark' : 'light';
        } else {
            newTheme = pref;
        }
        setActualTheme(newTheme);
        // Aplica o tema ao HTML para que o Bootstrap o reconheça
        document.documentElement.setAttribute('data-bs-theme', newTheme);
    }, []);

    // Aplica o tema sempre que a preferência do usuário mudar
    useEffect(() => {
        applyTheme(themePreference);
    }, [themePreference, applyTheme]);

    // Adiciona um listener para mudanças na preferência do sistema
    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        
        const handleChange = () => {
            if (themePreference === 'system') {
                applyTheme('system');
            }
        };

        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, [themePreference, applyTheme]);

    // Função para ser chamada pelos botões, atualiza o estado e o localStorage
    const setTheme = (newThemePreference) => {
        localStorage.setItem('theme', newThemePreference);
        setThemePreference(newThemePreference);
    };

    const value = { 
        theme: actualTheme, // O tema atual (light/dark)
        setTheme,           // A função para mudar a preferência
        themePreference     // A preferência salva (light/dark/system)
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};
